import request from "@/utils/request";

export function getApiUsageDaily(data, signal) {
  return request({
    url: "/api_keys/usage/daily",
    method: "post",
    data,
    signal,
  });
}

export function getApiUsageBreakdown(data, signal) {
  return request({
    url: "/api_keys/usage/breakdown",
    method: "post",
    data,
    signal,
  });
}

export function getApiUsageHealth(data, signal) {
  return request({
    url: "/api_keys/usage/health",
    method: "post",
    data,
    signal,
  });
}

export function getApiUsageHealthEndpoints(data, signal) {
  return request({
    url: "/api_keys/usage/health/endpoints",
    method: "post",
    data,
    signal,
  });
}

export function getApiUsageHealthErrors(data, signal) {
  return request({
    url: "/api_keys/usage/health/errors",
    method: "post",
    data,
    signal,
  });
}
